import { render, staticRenderFns } from "./custom-chip.vue?vue&type=template&id=6a82c15c&scoped=true"
import script from "./custom-chip.vue?vue&type=script&lang=js"
export * from "./custom-chip.vue?vue&type=script&lang=js"
import style0 from "./custom-chip.vue?vue&type=style&index=0&id=6a82c15c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a82c15c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a82c15c')) {
      api.createRecord('6a82c15c', component.options)
    } else {
      api.reload('6a82c15c', component.options)
    }
    module.hot.accept("./custom-chip.vue?vue&type=template&id=6a82c15c&scoped=true", function () {
      api.rerender('6a82c15c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bet-panel/chip/custom-chip.vue"
export default component.exports